export const NOTIFICATION_SUCCESS = 'NOTIFICATION_SUCCESS';
